import { createRoot } from 'react-dom/client'
import { App } from './App'
import { initMetrics } from '@/metrics/metrics'
import { inheritHostFont } from '@/utils/inheritHostFont'
import { trackFocusModality } from '@/utils/focusModality'
import { warnSkippedProperties } from '@/utils/portfolioDebug'
import './styles/main.css'

// Publish window.SPACES.events before render so consumers attaching on
// DOMContentLoaded can subscribe before the first event is emitted.
initMetrics()

const container = document.getElementById('spaces-app')

if (container) {
	// Runs before render so the host font is in place on first paint.
	inheritHostFont(container)
	trackFocusModality()
	warnSkippedProperties()

	const root = createRoot(container)
	root.render(<App />)
}
